export default __webpack_public_path__ + "static/media/visa-logo-new.c65852d8.svg";